import "./styles.scss";

export const Icon = ({ children, active, onClick, disabled = false, tooltip }) => {
  return (
    <span className={`icon-wrapper ${disabled ? "icon-disabled" : ""}`}>
      <p className={`icon ${active ? "active" : ""}`} onClick={onClick}>
        {children}
      </p>
      {tooltip && <span className="icon-tooltip">{tooltip}</span>}
    </span>
  );
};
